import { Link } from "react-router-dom";
import { Globe, ArrowRight } from "lucide-react";
import { globalReach, globalStats, homeBase } from "@/data/globalReach";
import SectionGlow from "@/components/site/SectionGlow";
import Reveal from "@/components/site/Reveal";

/**
 * GlobalPreview — a compact reach teaser (headline stat + a small country
 * constellation) that routes into the full /global network page.
 */
export const GlobalPreview = () => {
    const isos = (globalReach || []).slice(0, 12);
    const base = (homeBase?.name || "Bangladesh").split(" \u00b7")[0];

    return (
        <section id="global" className="pg-section pg-surface-ink" data-testid="home-global-preview" aria-label="Global reach">
            <SectionGlow tone="cool" />
            <div className="pg-container">
                <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center lg:gap-14">
                    <Reveal className="lg:col-span-6">
                        <span className="pg-eyebrow inline-flex items-center gap-2">
                            <Globe className="h-3.5 w-3.5" /> Global · Creative Reach
                        </span>
                        <h2 className="font-display mt-5 text-[clamp(2rem,4.6vw,3.2rem)] leading-[1.06]" style={{ color: "var(--pg-fg)" }}>
                            From {base}, to a <span className="pg-text-gold-static">global footprint</span>.
                        </h2>
                        <p className="mt-5 max-w-md text-base leading-relaxed sm:text-lg" style={{ color: "var(--pg-fg-muted)" }}>
                            Brand work flowing to clients across {globalStats.totalCountries}+ countries and counting.
                        </p>
                        <Link to="/global" data-testid="home-global-cta" className="pg-btn-primary mt-8 inline-flex">
                            See the network
                            <ArrowRight className="h-4 w-4" strokeWidth={1.6} />
                        </Link>
                    </Reveal>

                    <Reveal delay={0.08} className="lg:col-span-6">
                        <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
                            {isos.map((c) => (
                                <div
                                    key={c.iso}
                                    className="rounded-2xl border p-4 text-center"
                                    style={{ borderColor: "var(--pg-border)", background: "var(--pg-surface)" }}
                                >
                                    <div className="font-mono text-sm uppercase tracking-[0.16em]" style={{ color: "var(--pg-fg)" }}>{c.iso}</div>
                                    <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--pg-fg-muted)" }}>
                                        {c.projects} projects
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

export default GlobalPreview;
